import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useServicePageCms from '../../hooks/useServicePageCms';
import ServicesHero from './ServicesHero';
import ServicePageBody from './ServicePageBody';

const Radiology = () => {
  const { content } = useServicePageCms('radiology');
  const navigate = useNavigate();

  return (
    <Box>
      <ServicesHero
        title={content.title}
        subtitle={content.subtitle}
        serviceType="radiology"
      />

      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
            {content.introTitle}
          </Typography>
          <Typography variant="h6" paragraph sx={{ maxWidth: 800, mx: 'auto', lineHeight: 1.8, color: 'text.secondary' }}>
            {content.introText}
          </Typography>
        </Box>

        <ServicePageBody
          content={content}
          inContainer={false}
          clickableArticles
          onArticleClick={(slug) => navigate(`/services/radiology/${slug}`)}
        />
      </Container>
    </Box>
  );
};

export default Radiology;
